/**
 * What the validator made of the code, shown under the editor.
 *
 * Nothing here is removed from what a business wrote - custom questions are
 *  meant to be able to load a library and call an API. What this does is say
 *  out loud what the code reaches and what it looks like it collects, so
 *  neither the author nor we find out from a client.
 */
const CodeReview = ({ review, className = '' }) => {
    if (!review) {
        return null;
    }

    const errors = review.errors || [];
    const warnings = review.warnings || [];
    const notes = review.notes || [];
    const settingsProblems = review.settings_problems || [];
    const origins = review.external_origins || [];

    const hasAnything =
        errors.length ||
        warnings.length ||
        notes.length ||
        settingsProblems.length;

    if (!hasAnything) {
        return (
            <div className={`text-gray-500 text-sm mt-2 ${className}`}>
                Nothing to flag in this code.
            </div>
        );
    }

    return (
        <div className={`mt-3 text-sm ${className}`}>
            {errors.map((message, idx) => (
                <div key={`e${idx}`} className="text-red-600 mb-1">
                    {message}
                </div>
            ))}

            {settingsProblems.map((message, idx) => (
                <div key={`s${idx}`} className="text-red-600 mb-1">
                    {message}
                </div>
            ))}

            {warnings.map((message, idx) => (
                <div key={`w${idx}`} className="text-amber-700 mb-1">
                    {message}
                </div>
            ))}

            {notes.map((message, idx) => (
                <div key={`n${idx}`} className="text-gray-500 mb-1">
                    {message}
                </div>
            ))}

            {origins.length > 0 && (
                <div className="mt-2 text-gray-500">
                    <div className="font-semibold">Reaches</div>
                    <ul className="font-mono text-xs mt-1">
                        {origins.map(origin => (
                            <li key={origin}>{origin}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default CodeReview;
